import Grid from "@mui/material/Grid";
import { styled } from "@mui/system";

const StyledWrapper = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "15px",
  flex: "0 0 331px",
  width: "331px",
  maxWidth: "100%",
  minWidth: 0,
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
  [theme.breakpoints.down("md")]: {
    flex: "0 0 300px",
    width: "300px",
    margin: "0 auto",
    gap: "10px",
  },
  [theme.breakpoints.down("sm")]: {
    flex: "0 0 260px",
    width: "260px",
    gap: "8px",
  },
  ".person-image": {
    position: "relative",
    borderRadius: "50%",
    width: "100%",
    maxWidth: "300px",
    aspectRatio: "1 / 1",
    overflow: "hidden",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    cursor: "pointer",
    [theme.breakpoints.down("md")]: {
      maxWidth: "260px",
    },
    "&:hover .person-overlay-box": {
      opacity: 1,
    },
    "&:hover .person-arrow": {
      opacity: 1,
    },
    "&.active-popover .person-overlay-box": {
      opacity: 0,
    },
    "&.active-popover .person-arrow": {
      opacity: 0,
    },
    "&.active-popover:hover .person-overlay-box": {
      opacity: 0,
    },
    "&.active-popover:hover .person-arrow": {
      opacity: 0,
    },
  },
  ".person-image.active-popover": {
    zIndex: 10,
    [theme.breakpoints.down("sm")]: {
      zIndex: 0,
    },
  },
  ".person-overlay-box": {
    position: "absolute",
    inset: 0,
    backgroundColor: theme.palette.primary.main,
    mixBlendMode: "multiply",
    opacity: 0,
    transition: "opacity 0.25s ease",
    pointerEvents: "none",
  },
  ".person-arrow": {
    position: "absolute",
    bottom: "22px",
    left: "50%",
    transform: "translateX(-50%)",
    color: `${theme.palette.white.main} !important` as string,
    fontSize: "48px !important" as string,
    opacity: 0,
    transition: "opacity 0.25s ease",
    pointerEvents: "none",
    zIndex: 2,
    filter: "drop-shadow(0 2px 6px rgba(0,0,0,0.4))",
    [theme.breakpoints.down("xs")]: {
      fontSize: "40px !important" as string,
      bottom: "16px",
    },
  },
  ".person-content-holder": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "5px",
    width: "100%",
    minWidth: 0,
  },
  ".person-name-holder": {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "8px",
    width: "100%",
    minWidth: 0,
  },
  ".person-firstname": {
    fontSize: "30px",
    lineHeight: "35px",
    color: theme.palette.primary.main,
    textAlign: "center",
    overflowWrap: "anywhere",
    wordBreak: "break-word",
    maxWidth: "100%",
    [theme.breakpoints.down("md")]: {
      fontSize: "22px",
      lineHeight: "26px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
      lineHeight: "22px",
    },
  },
  ".person-firstname.organizer": {
    [theme.breakpoints.down("sm")]: {
      color: theme.palette.white.main,
    },
  },
  ".person-lastname": {
    fontSize: "28px",
    lineHeight: "35px",
    color: theme.palette.common.black,
    textAlign: "center",
    overflowWrap: "anywhere",
    wordBreak: "break-word",
    maxWidth: "100%",
    [theme.breakpoints.down("md")]: {
      fontSize: "22px",
      lineHeight: "26px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "18px",
      lineHeight: "22px",
    },
  },
  ".person-lastname.organizer": {
    [theme.breakpoints.down("sm")]: {
      color: theme.palette.white.main,
    },
  },
  ".person-role": {
    fontSize: "22px",
    lineHeight: "26px",
    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      fontSize: "16px",
      lineHeight: "19px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      lineHeight: "17px",
    },
  },
  ".person-role.organizer": {
    [theme.breakpoints.down("sm")]: {
      color: theme.palette.white.main,
    },
  },
  ".popover": {
    position: "absolute",
    top: "145px",
    left: "-114px",
    right: 0,
    bottom: 0,
    zIndex: 0,
    backgroundColor: theme.palette.primary.main,
    width: "560px",
    height: "640px",
    transition: "visibility 0s, opacity 0.3s linear",
    overflow: "hidden",
    opacity: 0,
    visibility: "hidden",
    [theme.breakpoints.down("lg")]: {
      width: "450px",
      height: "580px",
      top: "210px",
      left: "-65px",
    },
    [theme.breakpoints.down("sm")]: {
      width: "400px",
      height: "360px",
      top: "0",
      left: "-50px",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      height: "360px",
      top: "0",
      left: "-0px",
    },
  },
  ".popover.active": {
    zIndex: 2,
    opacity: 1,
    visibility: "visible",
  },
  ".popover-overlay": {
    display: "none",
  },
  ".popover-person-name-holder": {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
  },
  ".popover-text-box": {
    position: "absolute",
    zIndex: 4,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    padding: "0 30px",
    height: "100%",
    top: "170px",
    [theme.breakpoints.down("lg")]: {
      top: "100px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "0px 24px",
      justifyContent: "center",
      bottom: "unset",
      top: "0",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "0px 16px",
    },
  },
  ".popover-name": {
    fontSize: "28px",
    lineHeight: "35px",
    textAlign: "center",
    color: theme.palette.white.main,
    marginBottom: "5px",
    [theme.breakpoints.down("lg")]: {
      display: "none",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  ".popover-role": {
    fontSize: "24px",
    lineHeight: "24px",
    textAlign: "center",
    color: theme.palette.white.main,
    marginBottom: "20px",
    [theme.breakpoints.down("lg")]: {
      display: "none",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  ".popover-description": {
    fontSize: "18px",
    lineHeight: "24px",
    textAlign: "center",
    color: theme.palette.white.main,
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
      lineHeight: "24px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "14px",
      lineHeight: "20px",
    },
  },
  ".popover-description.organizer": {
    [theme.breakpoints.down("sm")]: {
      color: theme.palette.common.black,
    },
  },
}));

export default StyledWrapper;
